import { RelevantArticle } from "supportbeacon/model";

export const getTranslation = (translations: server.dto.ArticleTranslation[]) => {
  const uiLanguage = serverReference.languages.find(lang => lang.twoLetterTag === site.culture.uiLanguage)?.value ?? "english";

  const translation = translations.find(trans => trans.language === uiLanguage) ||
    translations.find(trans => trans.language === "english");

  return translation;

}

export const getRelevantArticles = (article: server.dto.Article): RelevantArticle[] => {

  return article.relatedArticles.map<RelevantArticle>(rel => {
    const relevantArticleTranslation = getTranslation(rel.translations);
    return {
      title: relevantArticleTranslation.title,
      slug: relevantArticleTranslation.slug,
      articleId: rel.articleId
    }
  });
}